// extracted by mini-css-extract-plugin
export default {"container":"DualValueListInput_container__AcMg0","inputs":"DualValueListInput_inputs__fOwhz","note":"DualValueListInput_note__nSWy+"};